import { IContainer } from '../../interface/container';
import { injectFetch } from '../../interface/util';
import { injectConfigAPI } from '../../interface/config';
import { IAuthAPI } from '../interface/auth';
import _authenticate from './auth';

function auth(container: IContainer): IAuthAPI {
    const fetcher = injectFetch(container);
    const configAPI = injectConfigAPI(container);

    const auth: IAuthAPI = {
        authenticate: (apiURL: string, username: string, password: string, timeout?: number) =>
            _authenticate(
                fetcher,
                apiURL,
                configAPI.extension.auth,
                { ...configAPI.auth, username, password },
                timeout ?? 10 * 1000,
            ),
    };

    return auth;
}

export default auth;
